/**
 * @file index.tsx
 *
 * @fileoverview Shows organization benefits.
 */
import { OrganizationBenefitsWidgetView } from '~/jobiqo/components/Organization/Widgets/Benefits/View';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { OrganizationBenefitsWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/Benefits/Empty';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

const KEY = 'benefits';

export interface OrganizationBenefitsWidgetProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * Field to update id
   */
  fieldToUpdateId?: string;
  /**
   * On form cancel callback
   */
  onCancel?: () => void;
}

export const OrganizationBenefitsWidget = ({
  organization,
}: OrganizationBenefitsWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  if (!organization.benefits?.length) {
    // Return empty benefits.
    return (
      <OrganizationBenefitsWidgetEmpty
        boxId={KEY}
        organization={organization}
      />
    );
  }

  return (
    <OrganizationBenefitsWidgetView boxId={KEY} organization={organization} />
  );
};
